import * as signalR from "@microsoft/signalr";

let connection = null;
let connectionUserId = null;

function buildConnection(userId) {
    return new signalR.HubConnectionBuilder()
        .withUrl(`${process.env.REACT_APP_BASE_URL}/notificationHub?userId=${encodeURIComponent(userId)}`, {
            withCredentials: false
        })
        .withAutomaticReconnect()
        .build();
}

export const startConnection = async () => {
    try {
        let userId = getUserId();
        if(userId === null || userId === undefined){
            return;
        }

        // Rebuild if this is the first connection or the logged-in user changed,
        // since the hub URL embeds userId and can't be updated on an existing connection.
        if (connection && connectionUserId !== userId) {
            await stopConnection();
        }
        if (!connection) {
            connection = buildConnection(userId);
            connectionUserId = userId;
        }

        if(connection.state === signalR.HubConnectionState.Connected){
            return;
        }
        await connection.start();
    } catch (err) {
        console.error("SignalR Connection Error", err);
    }
};

export const stopConnection = async () => {
  if (connection && connection.state !== signalR.HubConnectionState.Disconnected) {
    await connection.stop();
  }
  connection = null;
  connectionUserId = null;
};


function getUserId(){
    
    const userInfo = localStorage.getItem("userinfo");  
    if (userInfo) {
        const user = JSON.parse(userInfo);
        return user.CustomerId;
    }   
    return null;
};


export const onNotification = (callback) => {
    connection?.on("ReceiveNotification", callback);
    return () => connection?.off("ReceiveNotification", callback);
};

export const onOrderStatusUpdate = (callback) => {
    connection?.on("OrderStatusUpdateNotification", callback);
    return () => connection?.off("OrderStatusUpdateNotification", callback);
};

export const onAdminNotification = (callback) => {
    connection?.on("ReceiveAdminNotification", callback);
    return () => connection?.off("ReceiveAdminNotification", callback);
};
